// Libraries
var React = require("react");

// components
var GenericRichText = require('../RichText/GenericRichText');
var CrossfadeImage = require("./CrossFadeImage");

// Style
require("./ImageCopy.scss"); 
require("./ImageCopyAccordion.scss"); 

class ImageCopyAccordionModule extends React.Component { 

    constructor(props) {
        super(props);
        this.state = {
            image: this.props.data.blocks[0].image,
            activeAccordionIndex: 0,
            accordionGuid: this.guid(),
            animations: true
        }
    }

    componentDidMount() {
		
        if (typeof window === "undefined") return;

        document.addEventListener('openImageCopyAccordion', (e) => {

            const id = e.detail.id.replace('#', '');

            for (let i = 0; i < this.props.data.blocks.length; i++) {

                if (this.props.data.blocks[i].id === id) {

                    this.handleSetAccordion(i);
                    break;

                }
                
            }
    
        });

    }

    handleSetAccordion(index) {

        this.setState({
            activeAccordionIndex: index,
            image: this.props.data.blocks[index].image,
            animations: false
        });
        
        setTimeout(() => {
            
            this.setState({ animations: true });

        }, 500);

    }

    handleToggleAccordion(index) {

        this.setState({
            activeAccordionIndex: index === this.state.activeAccordionIndex ? null : index,
            image: index === this.state.activeAccordionIndex ? this.props.data.blocks[0].image : this.props.data.blocks[index].image
        });

    }

    guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
    }

    getAccordionMaxHeight(accordionContentId, isOpen) {
        if (typeof window === 'undefined') {
            if (isOpen) return 1000;
            return 0;
        }
        const targetContent = document.querySelector('#' + accordionContentId);
        if(isOpen) {
            if(targetContent) {
                return targetContent.scrollHeight;
            } else {
                return 1000;
            }
        }
        
        return 0;
    }

  render() {
    const additionalImageCopyClass = this.props.data.isOneHotspur ? ' c-image-copy--one-hotspur' : this.props.data.isPremium ? ' c-image-copy--premium' : '';
    const additionalSectionPadding = this.props.data.isOneHotspur ? ' c-section--one-hotspur' : '';


    return (
        <div className={`c-section c-section--flush${additionalSectionPadding}`} id={this.props.data.id}>
            <div className="c-section__inner">
                <div className={`c-image-copy c-image-copy--accordion${additionalImageCopyClass}`}>
                    <div className="c-image-copy__item">
                        <div className="c-image-copy__image-container">
                            <CrossfadeImage image={this.state.image} />
                        </div>
                        <div className="c-image-copy__copy">
                            <div className="c-image-copy__copy-inner">
                                <h2 className="c-image-copy__accordion-title">{this.props.data.title}</h2>
                                {this.props.data.blocks.map((accordionItem,index) => {    
                                    const accordionId = 'accordion-' + index + this.state.accordionGuid;
                                    return(
                                        <div key={index} className={`c-image-copy__accordion${!this.state.animations ? ' c-image-copy__accordion--no-animations' : ''}`} id={accordionItem.id}>
                                            <h3 className="c-image-copy__accordion-subtitle">
                                                <button type="button" className="c-image-copy__accordion-trigger" aria-expanded={index === this.state.activeAccordionIndex} aria-controls={accordionId} onClick={this.handleToggleAccordion.bind(this, index)}>
                                                    <span className="c-image-copy__accordion-trigger__text">{accordionItem.title}</span>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="23.996" height="14.897" viewBox="0 0 23.996 14.897" className="c-image-copy__accordion-trigger-icon">
                                                        <path data-name="Path 399" d="M12 14.9 0 2.9 2.9 0 12 9.1 21.1 0 24 2.9Z" fill="currentColor"/>
                                                    </svg>
                                                </button>
                                            </h3>
                                            <div className="c-image-copy__accordion-content" style={{ maxHeight: this.getAccordionMaxHeight(accordionId, this.state.activeAccordionIndex === index) }} aria-hidden={this.state.activeAccordionIndex === index ? "false" : "true"} id={accordionId}>
                                                <div className="c-image-copy__accordion-content-inner">
                                                    <GenericRichText content={accordionItem.richtext} isPremium={this.props.data.isPremium} />
                                                    <div className="c-image-copy__footer">
                                                        {accordionItem.links.map((link,linkIndex) => {    
                                                            return (
                                                                <div className="c-image-copy__link-container" key={linkIndex}>
                                                                    <a href={link.url} className="c-image-copy__link" target={link.newWindow ? "_blank" : "_self"} rel={link.newWindow ? "noopener noreferrer" : undefined}>{link.caption}</a>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
  }
}

module.exports = ImageCopyAccordionModule;



// WEBPACK FOOTER //
// ./src/components/ImageCopy/ImageCopyAccordion.js